import { WHITE } from '../../constants';

export const VouchedStyles = {
  container: {
    maxWidth: '688px',
    minHeight: 'calc(100vh - 62px - 44px)',
    borderRadius: '12px',
    padding: '22px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '36px',
    margin: '0 auto',
    '@media (max-width:600px)': {
      maxWidth: '331px',
      minHeight: 'calc(100vh - 14px - 44px)',
    },
  },

  imageBox: {
    width: '122.99px',
    height: '157.99px',
  },

  image: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
  },

  textBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    gap: '12px',
    '@media (max-width:600px)': {
      transform: 'rotate(0deg)',
      opacity: 1,
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
    },
  },

  heading: {
    fontFamily: 'TTNORMSPROBOLD',
    fontWeight: 700,
    fontSize: '32px',
    lineHeight: '100%',
    letterSpacing: '0px',
    color: '#313131',
  },

  subtext: {
    fontFamily: 'Arial',
    fontWeight: 400,
    fontSize: '16px',
    color: '#313131',
    lineHeight: '100%',
    letterSpacing: '0px',
  },

  buttonGroup: {
    width: '100%',
    display: 'flex',
    gap: '12px',
    '@media (max-width:600px)': {
      height: '48px',
      transform: 'rotate(0deg)',
      opacity: 1,
      display: 'flex',
      flexDirection: 'row',
      gap: '12px',
    },
  },

  outlinedButton: {
    width: '100%',
    padding: '14px 50px',
    height: '48px',
    borderRadius: '56px',
    // border: '1px solid #800080',
    // color: '#800080',
    fontWeight: 600,
    fontSize: '16px',
    textTransform: 'none',
    '@media (max-width:600px)': {
      maxWidth: '133px',
    },
    '&:hover': {
      background: 'transparent !important',
    },
  },

  containedButton: {
    width: '100%',
    padding: '14px 50px',
    height: '48px',
    borderRadius: '56px',
    fontWeight: 600,
    fontSize: '16px',
    textTransform: 'none',
  },
};

export const VouchedFailed = {
  container: {
    maxWidth: '688px',
    minHeight: 'calc(100vh - 62px - 44px)',
    borderRadius: '12px',
    padding: '32px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '36px',
    margin: '0 auto',
    '@media (max-width:600px)': {
      maxWidth: '331px',
      minHeight: 'calc(100vh - 14px - 44px)',
    },
  },

  imageBox: {
    width: 122.99,
    height: 157.99,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  image: {
    width: '96px',
    height: '96px',
    objectFit: 'contain',
    display: 'block',
  },

  textBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '12px',
    marginTop: '-43px',
    '@media (max-width:600px)': {
      width: '331px',
      height: '128px',
      transform: 'rotate(0deg)',
      opacity: 1,
      display: 'flex',
      gap: '8px',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },

  heading: {
    width: '630px',
    height: '40px',
    fontFamily: 'TTNORMSPROBOLD',
    fontWeight: 700,
    fontSize: '36px',
    lineHeight: '40px',
    letterSpacing: '0px',
    textAlign: 'center',
    color: '#D5151F',
    '@media (max-width:600px)': {
      width: '277px',
      height: '80px',
      fontFamily: 'Arial',
    },
  },

  subtext: {
    width: '527px',
    height: '20px',
    lineHeight: '20px',
    letterSpacing: '0px',
    textAlign: 'center',
    '@media (max-width:600px)': {
      width: '277px',
      height: '40px',
    },
  },

  buttonGroup: {
    display: 'flex',
    flexDirection: 'row',
    gap: '12px',
    marginTop: '16px',
    '@media (max-width:600px)': {
      width: '331px',
      height: '52px',
      transform: 'rotate(0deg)',
      opacity: 1,
      display: 'flex',
      gap: '12px',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },

  outlinedButton: {
    fontWeight: '700 !important',
    width: 309,
    height: 52,
    borderRadius: '56px',
    textTransform: 'none',
    // '&:hover': {
    //   background: '#fbe9e7',
    // },
  },

  containedButton: {
    color: '#fff',
    textTransform: 'none',
    // '&:hover': {
    //   background: '#b71c1c',
    // },
    width: '309px',
    height: '52px',
    borderRadius: '56px',
    transform: 'rotate(0deg)',
    opacity: 1,
    display: 'flex',
    gap: '10px',
    paddingTop: '14px',
    paddingRight: '50px',
    paddingBottom: '14px',
    paddingLeft: '50px',
    background: '#D5151F',
    alignItems: 'center',
    justifyContent: 'center',
  },

  infoText: {
    marginTop: '32px',
    color: '#666',
    textAlign: 'center',
    fontSize: '1rem',
  },
  textBoxStyle: {
    transform: 'rotate(0deg)',
    opacity: 1,
    fontFamily: 'Arial',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '20px',
    letterSpacing: '0px',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  refreshimage: {
    width: '24px',
    height: '24px',
    transform: 'rotate(0deg)',
    opacity: 1,
    display: 'inline-block',
  },
  backdrop: {
    zIndex: 1301,
    color: WHITE,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px',
  },
};
